import React from 'react';
import ActivityMonitor from '../components/activity-monitor/ActivityMonitor';

const ActivityMonitorHOC = (WrappedComponent) => {
    return class extends React.Component {
        render() {
            return (
                <React.Fragment>
                <WrappedComponent {...this.props} />
                <ActivityMonitor />
                </React.Fragment>
            )
        }
    }
}

export default ActivityMonitorHOC;
